import Image from "next/image"
import SearchInput from "./SearchInput"
import { useTranslation } from "next-i18next"

const SearchContent = () => {
    const { t } = useTranslation(["blog"])

    return (
        <div className="container mx-auto">
            <div className="grid items-center grid-cols-2 py-16 lg:space-x-12">
                <div className="col-span-12 mx-4 lg:space-y-8 lg:col-span-1 lg:mx-0">
                    <h1 className="text-3xl font-bold text-center text-black lg:text-left lg:text-6xl">{t("blog:blogTitle")}</h1>
                    <SearchInput />
                </div>

                <div className="col-span-12 lg:col-span-1">
                    <Image
                        src="/searchContent.svg"
                        width={572}
                        height={572}
                        alt="Makdos"
                        title="Makdos"
                    />
                </div>
            </div>
        </div>
    )
}

export default SearchContent